import '../../styles/theme.scss';
import '../../styles/theme.scss.liquid';

import '../../styles/customer-approval.scss';
import '../../styles/header.scss';
import '../../styles/cart-item.scss';
import '../../styles/column-carousel.scss';
import '../../styles/upgrade-your-browser.scss';

import '../sections/header';
import '../sections/footer';

import '../sections/column-carousel';

import io from '../utils/intersection-observer';

document.addEventListener('DOMContentLoaded', (event) => {
  document.querySelectorAll('img[defer]').forEach((el) => {
    if(Modernizr.touchevents && el.dataset.isHoverimage) {
      return;
    } else {
      io.observe(el);
      el.setAttribute('deferred', true)
    }
  });

  document.querySelectorAll('video[defer]').forEach((el) => {
    io.observe(el);
  });
});

let scrollY1 = scrollY;
let scrollY2 = 0;
let scrollDelta = 0;

window.addEventListener('scroll', (event) => {
  scrollY1 = scrollY2;
  scrollY2 = scrollY;
  scrollDelta = scrollY2 - scrollY1;
  requestAnimationFrame((event) => {
    if (scrollDelta < 0) {
      document.documentElement.dataset.scrollDirection = 'up';
    } else {
      document.documentElement.dataset.scrollDirection = 'down';
    }
  });
});
